import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Показываем загрузку пока проверяется аутентификация
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="loader mx-auto mb-4"></div>
          <p className="text-gray-600">Проверка авторизации...</p>
        </div>
      </div>
    );
  }

  // Если не авторизован, перенаправляем на авторизацию
  if (!isAuthenticated) {
    const backgroundLocation = location.state?.backgroundLocation;
    return (
      <Navigate
        to="/auth"
        state={backgroundLocation ? { from: location, backgroundLocation } : { from: location }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
